<template>
  <div class="layout">
    <Row>
      <h1 class='title' style="font-size: 16px;">
        <strong>{{this.$t('performanceQueryDetail.perfScoreDetails')}}</strong><!-- 指标得分明细 -->
      </h1>
    </Row>
    <Row type="flex" justify="center" class="code-row-bg">
      <Col span="16">
      <Row style="padding-bottom:10px">
        <Col span="3" class="txt2">
        <label>{{this.$t('performanceQueryDetail.supplierName')}}</label></Col><!-- 供应商名称 -->
        <Col span="9">
        <Input v-model="fromObj.vendorName" readonly></Input></Col>
        <Col span="3" class="txt2">
        <label>{{this.$t('performanceQueryView.category')}}</label></Col><!-- 采购分类 -->
        <Col span="9">
        <Input style="width:200px" v-model="fromObj.categoryCode" readonly></Input></Col>
      </Row>
      <Row style="padding-bottom:10px">
        <Col span="3" class="txt2">
        <label>{{this.$t('performanceQueryView.organization')}}</label></Col><!-- 库存组织 -->
        <Col span="9">
        <Input v-model="fromObj.organizationName" readonly></Input></Col>
        <Col span="3" class="txt2">
        <label>{{this.$t('performanceQueryView.performanceMouth')}}</label></Col><!-- 绩效月份 -->
        <Col span="1">
        <Input style="width:200px" v-model="fromObj.perfMonth" readonly></Input></Col>
      </Row>
      <Row style="padding-bottom:10px">
        <Col span="3" class="txt2">
        <label style="letter-spacing:-0.5px;">{{this.$t('performanceQueryDetail.compPerfScore')}}</label></Col><!-- 绩效总分 -->
        <Col span="4">
        <Input v-model="fromObj.compositeScore" readonly></Input></Col>
        <Col span="3" class="txt2">
        <label>{{this.$t('performanceQueryDetail.perfRanking')}}</label></Col><!-- 绩效排名 -->
        <Col span="2">
        <Input v-model="fromObj.compositeRank" readonly></Input></Col>
        <Col span="3" class="txt2">
        <label>{{this.$t('performanceQueryDetail.supplierNumber')}}</label></Col><!-- 供应商数量 -->
        <Col span="1">
        <Input v-model="fromObj.vendorCount" style="width:200px" readonly></Input></Col>
      </Row>
      </Col>
      <Col span="8">
      <div id="trendId" style="width: 75%;height:175px;"></div>
      </Col>
    </Row>
    <hr/>
    <Row style="padding-bottom:15px;padding-top:15px;">
      <h2 style="font-size: 15px;">{{this.$t('performanceQueryDetail.costPerformance')}}</h2><!-- 成本绩效 -->
      <Form label-position="left" :label-width="110">
        <Row>
          <Col span="5">
          <FormItem :label="this.$t('performanceQueryDetail.costWeight')"><!-- 成本权重 -->
            <Input v-model="resultSource.infoCost.dimensionWeight" readonly></Input>
          </FormItem>
          </Col>
          <Col span="5" offset="1">
          <FormItem :label="this.$t('performanceQueryDetail.costScore')"><!-- 成本得分 -->
            <Input v-model="resultSource.infoCost.dimensionScore" readonly></Input>
          </FormItem>
          </Col>
        </Row>
      </Form>
      <Col span='24' style="padding-left:40px;padding-right:40px;padding-top:15px;">
      <Table border ref="tableId0" :columns="tableColumns0" :data="resultSource.infoCost.indicatorList"></Table>
      </Col>
    </Row>
    <hr/>
    <Row style="padding-bottom:15px;">
      <h2 style="font-size: 15px;">{{this.$t('performanceQueryDetail.qualityPerformance')}}</h2><!-- 品质绩效 -->
      <Form label-position="left" :label-width="110">
        <Row>
          <Col span="5">
          <FormItem :label="this.$t('performanceQueryDetail.qualityWeight')"><!-- 品质权重 -->
            <Input v-model="resultSource.infoQuality.dimensionWeight" readonly></Input>
          </FormItem>
          </Col>
          <Col span="5" offset="1">
          <FormItem :label="this.$t('performanceQueryDetail.qualityScore')"><!-- 品质得分 -->
            <Input v-model="resultSource.infoQuality.dimensionScore" readonly></Input>
          </FormItem>
          </Col>
          <Col span="5" offset="1">
          <FormItem :label="this.$t('performanceQueryDetail.qualityRanking')"><!-- 品质排名 -->
            <Input v-model="resultSource.infoQuality.dimensionRank" readonly></Input>
          </FormItem>
          </Col>
        </Row>
      </Form>
      <Col span='24' style="padding-left:40px;padding-right:40px;padding-top:15px;">
      <Table border ref="tableId1" :columns="tableColumns1" :data="resultSource.infoQuality.indicatorList"></Table>
      </Col>
    </Row>
    <hr/>
    <Row style="padding-bottom:15px;">
      <h2 style="font-size: 15px;">{{this.$t('performanceQueryDetail.businessPerformance')}}</h2><!-- 业务绩效 -->
      <Form label-position="left" :label-width="110">
        <Row>
          <Col span="5">
          <FormItem :label="this.$t('performanceQueryDetail.businessWeight')"><!-- 业务权重 -->
            <Input v-model="resultSource.infoBusiness.dimensionWeight" readonly></Input>
          </FormItem>
          </Col>
          <Col span="5" offset="1">
          <FormItem :label="this.$t('performanceQueryDetail.businessScore')"><!-- 业务得分 -->
            <Input v-model="resultSource.infoBusiness.dimensionScore" readonly></Input>
          </FormItem>
          </Col>
          <!-- 业务指标加权得分*供货难度系数 -->
          <Col span="12" offset="1" style="color:red;">
            {{this.$t('performanceQueryDetail.remarks1')}}
          </Col>
        </Row>
        <Row>
          <Col span="5">
          <FormItem :label="this.$t('performanceQueryDetail.businessRanking')"><!-- 业务排名 -->
            <Input v-model="resultSource.infoBusiness.dimensionRank" readonly></Input>
          </FormItem>
          </Col>
          <Col span="5" offset="1">
          <FormItem :label="this.$t('performanceQueryDetail.availabilityFactor')" ><!-- 供货难易度系数 -->
            <Input v-model="resultSource.infoBusiness.difficultyDegree" readonly></Input>
          </FormItem>
          </Col>
          <!-- 小类供货编码数量排名系数*0.7+小类供货数量占比排名系数*0.3 -->
          <Col span="12" offset="1" style="color:red;">
          {{this.$t('performanceQueryDetail.remarks2')}}
          </Col>
        </Row>
      </Form>
      <Col span='24' style="padding-left:40px;padding-right:40px;padding-top:15px;">
      <Table border ref="tableId2" :columns="tableColumns2" :data="resultSource.infoBusiness.indicatorList"></Table>
      </Col>
    </Row>
    <Row style="padding-left:60px">
      <Col span='16' offset='10'>
      <m-button type="primary" @click="goBack" style="margin-left:20px">{{this.$t('common.back')}}</m-button><!-- 返回 -->
      </Col>
    </Row>
  </div>
</template>
<script>
  import echarts from 'echarts';
  import httpservice from '../../../../utils/http';
  import {formatDateTime} from '@/utils/datetime-format.js';
  export default {
    name: 'PerformanceQueryDetail',
    data() {
      return {
        currLang: this.$i18n.locale,
        vendorCode: '',
        fromObj: {},
        resultSource: {
          infoCost: {
            fdId: null,
            dimensionCode: '',
            dimensionWeight: null,
            dimensionScore: null,
            dimensionRank: null,
            difficultyDegree: null,
            indicatorList: []
          },
          infoQuality: {
            fdId: null,
            dimensionCode: '',
            dimensionWeight: null,
            dimensionScore: null,
            dimensionRank: null,
            difficultyDegree: null,
            indicatorList: []
          },
          infoBusiness: {
            fdId: null,
            dimensionCode: '',
            dimensionWeight: null,
            dimensionScore: null,
            dimensionRank: null,
            difficultyDegree: null,
            indicatorList: []
          }
        },
        tableColumns0: [
          {
            title: this.$t('performanceQueryDetail.indexName'), // 指标名称
            key: 'indicatorName'
          },
          {
            title: this.$t('performanceQueryDetail.indexWeight') + '(%)', // 指标权重
            key: 'indicatorWeight'
          },
          {
            title: this.$t('performanceQueryDetail.indexScore'), // 指标得分
            key: 'indicatorScore'
          }
        ],
        tableColumns1: [
          {
            title: this.$t('performanceQueryDetail.indexName'), // 指标名称
            key: 'indicatorName'
          },
          {
            title: this.$t('performanceQueryDetail.indexDemeritPoints'), // 指标总扣分
            key: 'indicatorScore'
          }
        ],
        tableColumns2: [
          {
            title: this.$t('performanceQueryDetail.indexName'), // 指标名称
            key: 'indicatorName'
          },
          {
            title: this.$t('performanceQueryDetail.indexWeight') + '(%)', // 指标权重
            key: 'indicatorWeight'
          },
          {
            title: this.$t('performanceQueryDetail.indexScore'), // 指标得分
            key: 'indicatorScore'
          }
        ]
      };
    },
    watch: {
      // 'questionDataCopy': function () {}
    },
    methods: {
      goBack() {
        this.$router.push({path: '/performance/performanceQueryView'});
      },
      query() {
        if (this.fromObj.vendorCode === undefined) {
          return;
        }
        let params = {};
        params.perfMonth = formatDateTime(new Date(this.fromObj.perfMonth), 'yyyyMM');  // '201801',
        params.vendorCode = this.fromObj.vendorCode;        // 'A0001672',
        params.orgCode = this.fromObj.organizationCode;     // 'M40',
        params.buCode = this.fromObj.buName.split('_')[1] || this.fromObj.buName;  // '117000',
        params.categoryCode = this.fromObj.categoryCode;    // 'CP201403120527'
        params.language = this.currLang;
        httpservice.post('/srmperf/gsc/composite/queryCompositeDetailInfo', params).then(res => {
          try {
              const { status, data, msg: content } = res.data;
              if (status === 0) {
                  this.resultSource = data;
              } else {
                  this.$Modal.error({
                      title: this.$t('common.warn'),
                      content,
                  });
              }
          } catch (err) {
              console.log('err:', err);
          }
        });
      }
    },
    mounted() {
      this.vendorCode = JSON.parse(localStorage.getItem('supplierInfo')).vendorCode;
      this.fromObj = JSON.parse(this.$route.query.row);
      let month = this.fromObj.perfMonth;
      this.fromObj.perfMonth = month ? month.substring(0, 4) + '-' + month.substring(4, 6) : ''; // '2019-09'
      this.query();
      var myChart = echarts.init(document.getElementById('trendId'));
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {          // 坐标轴指示器，坐标轴触发有效
            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          // data: ['扣分', '得分']
          data: [this.$t('performanceQueryDetail.demeritPoints'), this.$t('performanceQueryDetail.score')]
        },
        grid: {
          left: '5%',
          right: '5%',
          bottom: '5%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'value'
          }
        ],
        yAxis: [
          {
            type: 'category',
            axisTick: {show: false},
            // data: ['品质绩效   ', '成本绩效    ', '业务绩效   ']
            data: [this.$t('performanceQueryDetail.qualityPerformance') + '   ', this.$t('performanceQueryDetail.costPerformance') + '   ', this.$t('performanceQueryDetail.businessPerformance') + '   ']
          }
        ],
        series: [
          {
            name: this.$t('performanceQueryDetail.demeritPoints'), // 扣分
            type: 'bar',
            stack: '总量', // 总量
            label: {
              normal: {
                show: true,
                position: 'left'
              }
            },
            data: [-(100 - (this.fromObj.qualityScore === null ? 100 : this.fromObj.qualityScore)).toFixed(2), -(100 - (this.fromObj.costScore === null ? 100 : this.fromObj.costScore)).toFixed(2), -(100 - (this.fromObj.businessScore === null ? 100 : this.fromObj.businessScore)).toFixed(2)]
          },
          {
            name: this.$t('performanceQueryDetail.score'), // 得分
            type: 'bar',
            stack: '总量', // 总量
            label: {
              normal: {
                show: true
              }
            },
            data: [(this.fromObj.qualityScore === null ? 0 : this.fromObj.qualityScore), (this.fromObj.costScore === null ? 0 : this.fromObj.costScore), (this.fromObj.businessScore === null ? 0 : this.fromObj.businessScore)]
          }
        ]
      };
      myChart.setOption(option);
    }
  };
</script>

<style scoped lang='less'>
  .layout {
    margin: 10px;
    padding: 20px;
    background-color: #fff;
    .title {
      margin-bottom: 30px;
    }
  }
  /deep/ .m-form-label-left .m-form-item-label {
    text-align: right;
  }
</style>
